import { Component, OnInit, Input } from '@angular/core';
import { LpAssetReqRes } from '../../../LpAssetReqRes.model';
import AreaUnit from 'src/app/shared/enums/AreaUnit.enum';

@Component({
  selector: 'terra-asset-spend-to-date-section',
  templateUrl: './asset-spend-to-date-section.component.html',
  styleUrls: ['../../../../styles/holding/holding-page-shared.scss', './asset-spend-to-date-section.component.scss']
})
export class AssetSpendToDateSectionComponent implements OnInit {

  // Enums
  AreaUnit = AreaUnit;

  @Input() asset: LpAssetReqRes;


  constructor() { }

  ngOnInit() {
  }

}
